import React, { Component } from "react";
import { withRouter } from "./withRouter";
import mapboxgl from "mapbox-gl";
import { tableFromIPC } from "apache-arrow";
import { Box } from "@mui/material";
import MapComponent from "./MapComponent"
import { alpha } from '@mui/material/styles';
import ConstituencyGrid from "./ConstituencyGrid"
import NationalVoteBar from "./NationalVoteBar"
import CoalitionPerformanceBoxIssues from "./CoalitionPerformanceBoxIssues"

// matcher because named the columns stupidly
function getGroupKeys(polLevel) {
  const forward =
    polLevel === "past"
      ? {
          D66: "past_vote_D66",
          CDA: "past_vote_CDA",
          'GL-PvdA': "past_vote_GLpvdA",
        //  OtherCentre: "past_vote_OtherCentre",
        //  OtherLeft: "past_vote_OtherLeft",
         // OtherRight: "past_vote_OtherRight",
          PVV: "past_vote_PVV",
          VVD: "past_vote_VVD",
        }
      : (() => {
          const level = polLevel === "LE" ? "LE" : "GE";

          return {
            D66: `D66_${level}_p`,
            PVV: `PVV_${level}_p`,
            VVD: `VVD_${level}_p`,
            'GL-PvdA': `GLpvdA_${level}_p`,
            CDA: `CDA_${level}_p`,
            ...(polLevel === "LE" ? { Local: "Local_LE_p" } : {}),
         //   OtherRight: `OtherRight_${level}_p`,
          // OtherLeft: `OtherLeft_${level}_p`,
          //  OtherCentre: `OtherCentre_${level}_p`,
          //  Other: `Other_${level}_p`,
          };
        })();

  // invert it: longKey -> shortName
  return Object.fromEntries(
    Object.entries(forward).map(([shortName, longKey]) => [longKey, shortName])
  );
}

export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];

  
  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}
const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};

// Define party full names and official colours
const PARTY_INFO = {
    D66_GE_p: { name: "D66", color: "#2cc800" },
    D66_LE_p: { name: "D66", color: "#2cc800" },
    past_vote_D66: { name: "D66", color: "#2cc800" },
    PVV_GE_p: { name: "PVV", color: "#043555" },
    PVV_LE_p: { name: "PVV", color: "#043555" },
    past_vote_PVV: { name: "PVV", color: "#043555" },
    VVD_GE_p: { name: "VVD", color: "#0e2783" },
    VVD_LE_p: { name: "VVD", color: "#0e2783" },
    past_vote_VVD: { name: "VVD", color: "#0e2783" },
    GLpvdA_GE_p: { name: "GL-PvdA", color: "#920c19" },
    GLpvdA_LE_p: { name: "GL-PvdA", color: "#920c19" },
    past_vote_GLpvdA: { name: "GL-PvdA", color: "#920c19" },
    CDA_GE_p: { name: "CDA", color: "#339933" },
    CDA_LE_p: { name: "CDA", color: "#339933" },
    past_vote_CDA: { name: "CDA", color: "#339933" },
    OtherRight_GE_p: { name: "OtherRight", color: "#7393B3" },
    OtherRight_LE_p: { name: "OtherRight", color: "#7393B3" },
    past_vote_OtherRight: { name: "OtherRight", color: "#7393B3" },
    OtherLeft_GE_p: { name: "OtherLeft", color: "#997570" },
    OtherLeft_LE_p: { name: "OtherLeft", color: "#997570" },
    past_vote_OtherLeft: { name: "OtherLeft", color: "#997570" },
    OtherCentre_GE_p: { name: "OtherCentre", color: "#999999" },
    OtherCentre_LE_p: { name: "OtherCentre", color: "#999999" },
    past_vote_OtherCentre: { name: "OtherCentre", color: "#999999" },
    Other_GE_p: { name: "Other", color: "#d4d2d2ff" },
    //Other_LE_p: { name: "Other", color: "#d4d2d2ff" },
  Local_LE_p: { name: "Local", color: "#666666" },
};

// Build labels and colors in one go
const buildLabelsAndColors = () => {
  const labels = {};
  const colors = {};

  Object.entries(PARTY_INFO).forEach(([key, info]) => {
    labels[key] = info.name;
    colors[key] = info.color;
  });

  return { labels, colors };
};




class NL2026HomeIssues extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "geementen",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.GEEMENTENMap,
      styleLoaded: false,
      viewState: null,
     metricRowsConst: null,
      metricRowsNational:null,
      polLevel:"GE",
      councilSeatsByArea:null
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("geementen", null, true);
    await this.loadCouncilSeats();  
  };
  run();
}

   componentDidUpdate(prevProps, prevState) {
    const groupChanged      = prevProps.selectedGroupId !== this.props.selectedGroupId;
   
    const levelChanged      = prevState.geoLevel !== this.state.geoLevel;
    const polLevelChanged      = prevState.polLevel !== this.state.polLevel;

  
    const needRefetch = levelChanged  || groupChanged ;
    if (needRefetch) {
      this.fetchMetrics(this.state.geoLevel, this.state.selectedFeature?.area_id);
    }

  
    const rowsChanged  = prevState.metricRows !== this.state.metricRows;
    const geoChanged   = prevState.geoData !== this.state.geoData;
  
    if (geoChanged || rowsChanged || groupChanged||polLevelChanged) {
      this.restyle();
    }
  
   
    
  }
  _inflightBaseline = null;
  _lastBaselineKey = null;
  _lastBaselineAt = 0;
    requestKey = (level) => {

    return `${level}`;
  };


  parseCouncilSeatsCSV = (text) => {
  // Handles normal CSV, including municipality names with commas if they are quoted.
  // (If your file has no quoted commas, this is still fine.)
  const lines = text.trim().split(/\r?\n/);
  if (lines.length < 2) return {};

  const header = this.parseCSVLine(lines[0]);
  const codeIdx = header.indexOf("municipality_code");
  const nIdx = header.indexOf("n_councillors");

  if (codeIdx === -1 || nIdx === -1) return {};

  const out = {};
  for (let i = 1; i < lines.length; i += 1) {
    const line = lines[i];
    if (!line || !line.trim()) continue;

    const cols = this.parseCSVLine(line);
    const code = cols[codeIdx];
    const n = Number(cols[nIdx]);

    if (code && Number.isFinite(n)) out[code] = n;
  }
  return out;
};

// Basic CSV line parser that respects quotes.
parseCSVLine = (line) => {
  const result = [];
  let cur = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const ch = line[i];

    if (ch === '"') {
      // If double-quote inside quoted field -> literal quote
      if (inQuotes && line[i + 1] === '"') {
        cur += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (ch === "," && !inQuotes) {
      result.push(cur.trim());
      cur = "";
    } else {
      cur += ch;
    }
  }

  result.push(cur.trim());
  return result;
};

loadCouncilSeats = async () => {
  try {
    const res = await fetch("/council_size__by_municipality_code.csv");
    if (!res.ok) throw new Error(`CSV fetch failed: ${res.status}`);
    const text = await res.text();

    const councilSeatsByArea = this.parseCouncilSeatsCSV(text);
    this.setState({ councilSeatsByArea });

    // Optional sanity check
  } catch (e) {
    console.error("Failed to load council size CSV", e);
    this.setState({ councilSeatsByArea: {} });
  }
};


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;
  const polLevel=this.state.polLevel

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
    if(level==="national"||save_const_results){
          keysBody= [
            "D66_GE_p",
            "PVV_GE_p",
            "VVD_GE_p",
            "GLpvdA_GE_p",
            "CDA_GE_p",
            "OtherRight_GE_p",
            "OtherLeft_GE_p",
            "OtherCentre_GE_p",
            "Other_GE_p",
            "D66_LE_p",
            "PVV_LE_p",
            "VVD_LE_p",
            "GLpvdA_LE_p",
            "CDA_LE_p",
            "OtherRight_LE_p",
            "OtherLeft_LE_p",
            "OtherCentre_LE_p",
            "Local_LE_p",
           // "Other_LE_p",

            "D66_GE_p_lower",
            "D66_GE_p_upper",
            "PVV_GE_p_lower",
            "PVV_GE_p_upper",
            "VVD_GE_p_lower",
            "VVD_GE_p_upper",
            "GLpvdA_GE_p_lower",
            "GLpvdA_GE_p_upper",
            "CDA_GE_p_lower",
            "CDA_GE_p_upper",
            "OtherRight_GE_p_lower",
            "OtherRight_GE_p_upper",
            "OtherLeft_GE_p_lower",
            "OtherLeft_GE_p_upper",
            "OtherCentre_GE_p_lower",
            "OtherCentre_GE_p_upper",
            "Other_GE_p_lower",
            "Other_GE_p_upper",
            "turnout_LE_p_lower",
            "turnout_LE_p_upper",
            "D66_LE_p_lower",
            "D66_LE_p_upper",
            "PVV_LE_p_lower",
            "PVV_LE_p_upper",
            "VVD_LE_p_lower",
            "VVD_LE_p_upper",
            "GLpvdA_LE_p_lower",
            "GLpvdA_LE_p_upper" ,
            "CDA_LE_p_lower",
            "CDA_LE_p_upper",
            "OtherRight_LE_p_lower",
            "OtherRight_LE_p_upper",
            "OtherLeft_LE_p_lower",
            "OtherLeft_LE_p_upper",
            "OtherCentre_LE_p_lower",
            "OtherCentre_LE_p_upper",
            //"Other_LE_p_lower",
            //"Other_LE_p_upper",
            "Local_LE_p_lower",
            "Local_LE_p_upper",
            


            "turnout_GE_p",
            "turnout_LE_p",
            "turnout_GE_p_lower",
            "turnout_GE_p_upper",
            "turnout_LE_p_lower",
            "turnout_LE_p_upper",
            
            
            
            "health_nat_p",
            "climate_nat_p",
            "nitrogen_nat_p",
            "housing_nat_p",
            "immigration_nat_p", 
            "poverty_nat_p",
            "purchasing_nat_p",
            "safety_nat_p",
            "education_nat_p",
            "dutch_nat_p",
            "trust_nat_p",
            "defense_nat_p",
            "EU_nat_p",
            "staff_nat_p",
            "other_nat_p",
            "housing_local_p",
            "CoL_local_p",
            "traffic_local_p",
            "publicTransport_local_p",
            "safety_local_p",
            "health_local_p",
            "recycle_local_p",
            "education_local_p",
            "climate_local_p",
            "econ_local_p",
            "governance_local_p",
            "integration_local_p",
            "other_local_p",

            "past_vote_CDA",
            "past_vote_D66",
            "past_vote_DidNotVote",
            "past_vote_GLpvdA",
            "past_vote_OtherCentre",
            "past_vote_OtherLeft",
            "past_vote_OtherRight",
            "past_vote_PVV",
            "past_vote_VVD",


            "D66_consider" ,
            "PVV_consider" ,  
            "VVD_consider",    
            "GLpvdA_consider",
            "CDA_consider",
            "D66_consider_LE",
            "PVV_consider_LE",
            "VVD_consider_LE",
            "GLpvdA_consider_LE",
            "CDA_consider_LE",
            "Local_consider_LE" 
                  ]  
    }else{
    keysBody= [
            "D66_GE_p",
            "PVV_GE_p",
            "VVD_GE_p",
            "GLpvdA_GE_p",
            "CDA_GE_p",
            "OtherRight_GE_p",
            "OtherLeft_GE_p",
            "OtherCentre_GE_p",
            "D66_LE_p",
            "PVV_LE_p",
            "VVD_LE_p",
            "GLpvdA_LE_p",
            "CDA_LE_p",
            "OtherRight_LE_p",
            "OtherLeft_LE_p",
            "OtherCentre_LE_p",
            "Local_LE_p",

            "D66_GE_p_lower",
            "D66_GE_p_upper",
            "PVV_GE_p_lower",
            "PVV_GE_p_upper",
            "VVD_GE_p_lower",
            "VVD_GE_p_upper",
            "GLpvdA_GE_p_lower",
            "GLpvdA_GE_p_upper",
            "CDA_GE_p_lower",
            "CDA_GE_p_upper",
            "OtherRight_GE_p_lower",
            "OtherRight_GE_p_upper",
            "OtherLeft_GE_p_lower",
            "OtherLeft_GE_p_upper",
            "OtherCentre_GE_p_lower",
            "OtherCentre_GE_p_upper",
            "Other_GE_p_lower",
            "Other_GE_p_upper",
            "turnout_LE_p_lower",
            "turnout_LE_p_upper",
            "D66_LE_p_lower",
            "D66_LE_p_upper",
            "PVV_LE_p_lower",
            "PVV_LE_p_upper",
            "VVD_LE_p_lower",
            "VVD_LE_p_upper",
            "GLpvdA_LE_p_lower",
            "GLpvdA_LE_p_upper" ,
            "CDA_LE_p_lower",
            "CDA_LE_p_upper",
            "OtherRight_LE_p_lower",
            "OtherRight_LE_p_upper",
            "OtherLeft_LE_p_lower",
            "OtherLeft_LE_p_upper",
            "OtherCentre_LE_p_lower",
            "OtherCentre_LE_p_upper",
            //"Other_LE_p_lower",
            //"Other_LE_p_upper",
            "Local_LE_p_lower",
            "Local_LE_p_upper",
            
            "turnout_GE_p",
            "turnout_LE_p",
            "turnout_GE_p_lower",
            "turnout_GE_p_upper",
            "turnout_LE_p_lower",
            "turnout_LE_p_upper",
            
            
            
      "past_vote_CDA",
      "past_vote_D66",
      "past_vote_DidNotVote",
      "past_vote_GLpvdA",
      "past_vote_OtherCentre",
      "past_vote_OtherLeft",
      "past_vote_OtherRight",
      "past_vote_PVV",
      "past_vote_VVD",
                  "health_nat_p",
            "climate_nat_p",
            "nitrogen_nat_p",
            "housing_nat_p",
            "immigration_nat_p", 
            "poverty_nat_p",
            "purchasing_nat_p",
            "safety_nat_p",
            "education_nat_p",
            "dutch_nat_p",
            "trust_nat_p",
            "defense_nat_p",
            "EU_nat_p",
            "staff_nat_p",
            "other_nat_p",
            "housing_local_p",
            "CoL_local_p",
            "traffic_local_p",
            "publicTransport_local_p",
            "safety_local_p",
            "health_local_p",
            "recycle_local_p",
            "education_local_p",
            "climate_local_p",
            "econ_local_p",
            "governance_local_p",
            "integration_local_p",
            "other_local_p",
            


            "D66_consider" ,
            "PVV_consider" ,  
            "VVD_consider",    
            "GLpvdA_consider",
            "CDA_consider",
            "D66_consider_LE",
            "PVV_consider_LE",
            "VVD_consider_LE",
            "GLpvdA_consider_LE",
            "CDA_consider_LE",
            "Local_consider_LE" 
                  ]
                }
                
    let turnout_weight

    /// TO DO: fix this when local/general elction works
    turnout_weight = "turnout_GE_p"
    const body = {
      groupKeys: keysBody,
      filters:[],
      constCode: constCode,
    turnout_weight: turnout_weight

    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
                metricRows: rowsMain,})
            }
      }else{
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }


  getValueAndCI(row, key) {
  const value = Number(row?.[key]);
  const lower = Number(row?.[`${key}_lower`]);
  const upper = Number(row?.[`${key}_upper`]);

  return {
    value,
    lower: Number.isFinite(lower) ? lower : undefined,
    upper: Number.isFinite(upper) ? upper : undefined,
  };
}


 restyle = () => {
  const { geoData, metricRows, polLevel } = this.state;

  if (!geoData) {
    this.setState({ styledGeo: null });
    return;
  }
  if (!metricRows) return;

  const byId = new Map();
  for (const r of metricRows) {
    const id = String(r.area_id ?? "");
    if (id) byId.set(id, r);
  }

  const { labels, colors } = buildLabelsAndColors();

  const styled = {
    type: "FeatureCollection",
    features: geoData.features.map((f) => {
      const rid = String(f.properties?.area_id ?? "");
      const row = byId.get(rid);

      if (!row) {
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor: "#ffffff",
            topLabel: "No data",
            topValue: 0,
            _allValues: {},
            _allValuesSorted: [],
            Turnout: undefined,
          },
        };
      }

      const groupKeys = getGroupKeys(polLevel);
const displayKeys = Object.keys(groupKeys).filter((k) => k in row);


      if (displayKeys.length === 0) {
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor: "#ffffff",
            topLabel: "No data",
            topValue: 0,
            _allValues: {},
            _allValuesSorted: [],
            Turnout: undefined,
          },
        };
      }

      // Build entries with value + CI
      const entries = displayKeys
        .map((k) => {
          const { value, lower, upper } = this.getValueAndCI(row, k);
          return {
            key: k,
            area_name: labels[k] || k,
            value,
            lower,
            upper,
          };
        })
        .filter((e) => Number.isFinite(e.value))
        .sort((a, b) => b.value - a.value);

      let fillColor = "#666";
      let topKey = entries[0]?.key;
      let topLabel = entries[0]?.area_name || "";
      let topValue = entries[0]?.value ?? 0;
      let topLower = entries[0]?.lower;
      let topUpper = entries[0]?.upper;

      fillColor = colors[topKey] || "#000000";

      // Your ordering logic (Net at bottom) — extended to keep CI fields
      const sortedvals = entries
        .map((e) => ({
          ...e,
          order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0,
        }))
        .sort((a, b) => a.order - b.order)
        .map(({ order, ...e }) => e);

      // Turnout + CI
      let turnoutKey;
      switch (polLevel) {
        case "GE":
          turnoutKey = "turnout_GE_p";
          break;
        case "LE":
          turnoutKey = "turnout_LE_p";
          break;
        case "past":
          turnoutKey = "turnout_GE_p"; // your existing fallback
          break;
        default:
          turnoutKey = undefined;
      }

      const turnout =
        turnoutKey && turnoutKey in row
          ? { key: turnoutKey, ...this.getValueAndCI(row, turnoutKey) }
          : undefined;

      // Store everything in a consistent shape for tooltips/side panels
      const allValues = Object.fromEntries(
        entries.map((e) => [
          e.key,
          { label: e.area_name, value: e.value, lower: e.lower, upper: e.upper },
        ])
      );

      return {
        ...f,
        properties: {
          ...f.properties,
          fillColor,
          topKey,
          topLabel,
          topValue,
          topLower, // NEW
          topUpper, // NEW
          _allValues: allValues, // NEW STRUCTURE (key -> {label,value,lower,upper})
          _allValuesSorted: sortedvals, // each item has key, area_name, value, lower, upper
          Turnout: turnout, // { key, value, lower, upper } or undefined
        },
      };
    }),
  };

  this.setState({ styledGeo: styled, styleLoaded: true });
};

  fitBoundsFromFeatures = (features) => {
  if (!this.mapRef.current || !features?.length) return null;
  const map = this.mapRef.current.getMap();
  const bounds = new mapboxgl.LngLatBounds();
  this.setState({viewState:null})
  features.forEach(f => {
    const coords = f.geometry.type === "Polygon"
      ? f.geometry.coordinates.flat(1)
      : f.geometry.coordinates.flat(2);
    coords.forEach(([lng, lat]) => bounds.extend([lng, lat]));
  });
  map.fitBounds(bounds, { padding: 80, duration: 500 });
  return bounds;
};

  

   onMapClick = (evt) => {
    const feature = evt.features?.[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();


    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);

    

    const clickedLevel = level;

    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }

     if (level === "geementen") {
      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateBounds = zoomToFeature(feature); // sets map to state
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "buurt",
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "geementen",
            key: "gemeentecode",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("buurt",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("buurt", { doFit: false });
                
  
        }
      );
      return;
    }


  };

    onMouseMove = (evt) => {
        const feature = evt.features && evt.features[0];
        if (!feature) return this.setState({ hoverInfo: null,hoverAreaId:null });
    
        const { lng, lat } = evt.lngLat; 
        this.setState({
        hoverInfo: { lon: lng, lat, props: feature.properties },
        hoverAreaId: feature.properties.area_id ?? null
        });
    };

  loadGeo = async (level) => {
    let newGeo 
    switch(level){
        case "geementen":
         newGeo = this.props.GEEMENTENMap
        break
        case "buurt":
         newGeo = this.props.BUURTMap
        break

        
        default:
         newGeo = this.props.GEEMENTENMap
        break
    }
    this.setState({geoData: newGeo, geoLevel: level
    })
  }

 onGeoLevelChange = (newLevel) => {
  if (!newLevel) return;

  // if these are async functions already, await them
  this.fetchMetrics(newLevel, this.state.selectedFeature?.area_id);
  this.loadGeo(newLevel);

  // return when both finish
};

 onPolLevelChange = (newLevel) => {
  if (!newLevel) return;
  
    this.setState({polLevel: newLevel
    })

  // return when both finish
};
    // Utility: compute bounds [minX, minY, maxX, maxY] from a FeatureCollection
getFeatureCollectionBounds = (featureCollection) => {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  featureCollection.features.forEach((feat) => {
    const coords = feat.geometry.coordinates;

    const recurse = (arr) => {
      if (typeof arr[0] === "number") {
        const [x, y] = arr;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      } else {
        arr.forEach(recurse);
      }
    };

    recurse(coords);
  });

  return [[minX, minY], [maxX, maxY]];
};
    

   resetView = ({ LevelToResetTo = "geementen" }) => {
    const map = this.mapRef.current?.getMap();
      if (map) {
    map.fitBounds(
      [
      [3.3, 50.7],  // SW (south-west)
      [7.2, 53.6],  // NE (north-east)
      ],
      { padding: 80 }
    );
  }

  this.setState(
    {
      geoLevel: LevelToResetTo,
      selectedStateCode: null,
      selectedStateBounds: null,
      selectedFeature: null,
      metricRows: null,
      styledGeo: null,
      
    },
    () => {
      this.onGeoLevelChange(LevelToResetTo);

    }
  );
};

handleselectedFeatureChange =  (area_id, area_name) => {




    const feature = this.props.GEEMENTENMap.features.filter(
          f => String(f.properties.area_id) === String(area_id.area_id)
        )[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();

    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);   

    const clickedLevel = level;


    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }
      const stateBounds = zoomToFeature(feature); // sets map to state

      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "buurt",
          viewState:null,
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "geementen",
            key: "gemeentecode",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
            
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("buurt",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("buurt", { doFit: false });
                
  
        }
      );
      return;
    

    
}


  render() {
  
  return(
<Box
  sx={{
    display: "flex",
    height: "92vh",      // own the height here
    width: "100%",
    overflow: "hidden",  // no page scrollbar
  }}
>
  {/* LEFT COLUMN */}
  <Box
    component="main"
    sx={(theme) => ({
      flex: 1,
      minWidth: 0,             // important for flex children
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      backgroundColor: theme.vars
        ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
        : alpha(theme.palette.background.default, 1),
    })}
  >
        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        <MapComponent
            mapRef={this.mapRef}
            styledGeo={this.state.styledGeo}
            geoData={this.state.geoData}
            hoverInfo={this.state.hoverInfo}
            styleLoaded={this.state.styleLoaded}
            selectedFeature={this.state.selectedFeature}
            onMapClick={this.onMapClick}
            onMouseMove={this.onMouseMove}
            onGeoLevelChange={this.onGeoLevelChange}
            polLevel={this.state.polLevel}
            onPolLevelChange={this.onPolLevelChange}
            buildLabelsAndColors={buildLabelsAndColors}
            geoLevel={this.state.geoLevel}
            resetView={this.resetView}
            handleselectedFeatureChange={this.handleselectedFeatureChange}
            viewState={this.state.viewState}
            tooltip={"home"}
        />
        </Box>
    </Box>

    {/* RIGHT COLUMN */}
   <Box
        component="main"
        sx={(theme) => ({
            flex: 1,
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
               overflowY: "auto", 
            height: "100%",
            backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
        })}
        >
          
        {/* Main content flexes to fill */}
        <Box
            sx={{
            flex: 1,                 // take available height from parent
            display: "flex",
            flexDirection: "column",
            width:"100%"
            }}
        >
            {/* Top */}

              <Box
            sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 2,
                pt: { xs: 1, md: 1, lg:1, xl:1 },
                pb: { xs: 1, md: 1, lg:1, xl:1 },
            }}
            >
              
            <NationalVoteBar
                metricRowsConst={this.state.metricRowsConst}
                metricRowsNat={this.state.metricRowsNational}
                selectedFeature={this.state.selectedFeature}
                WIDTH="90%"
                polLevel={this.state.polLevel}
            />
            </Box>
            <Box
            sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 1,
                pt: { xs: 1, md: 1, lg:1, xl:1 },
                pb: { xs: 1, md: 5, lg:4, xl:10 },
            }}
            >
            <ConstituencyGrid
          polLevel={this.state.polLevel}                 // "GE" or "LE"
          metricRowsNational={this.state.metricRowsNational}
          metricRowsConst={this.state.metricRowsConst}
  councilSeatsByArea={this.state.councilSeatsByArea || {}} // { GM0748: 31, ... }
          councilSeatsDefault={29}          // or a number if you want a fallback
          seatSquaresUnit={1}                 // set to 5/10 if LE totals are too many squares
          square_size = {this.state.polLevel==="LE" && this.state.selectedFeature===null ? 4 : 15}
                selectedFeature={this.state.selectedFeature}
                  pastHardcodedSeatsByParty={{
                      PVV: 26,
                      VVD: 22,
                      'GL-PvdA': 20,
                      D66: 26,
                      CDA: 18,
                      OtherRight: 23,
                      OtherLeft: 10,
                      OtherCentre: 5,
                    }}
        />

            </Box>


            {/* Middle */}


            {/* Bottom pinned */}
            <Box sx={{ mt: "auto" }}>
            <CoalitionPerformanceBoxIssues
                metricRowsConst={this.state.metricRowsConst}
                metricRowsNat={this.state.metricRowsNational}
                selectedFeature={this.state.selectedFeature}
                electionType={this.state.polLevel}
            />
            </Box>
        </Box>
        </Box>

 </Box>


  )
}


  }

export default withRouter(NL2026HomeIssues);